import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "../../config";
import { Loader2, Bot, RefreshCw } from "lucide-react";
import { AgencyClientAiPanel, agencyAuth } from "./AgencyClientAiPanel";

const DOT = { action: "bg-purple-400", done: "bg-emerald-400", idle: "bg-gray-500" };
const initials = (name = "") => name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";

const FeedRow = ({ c, onOpen }) => (
  <div className="flex items-center gap-4 px-4 py-3.5 border-t border-gray-800 first:border-t-0 hover:bg-gray-900/60 transition-colors" data-testid={`agent-feed-row-${c.id}`}>
    <div className="w-9 h-9 shrink-0 rounded-sm bg-gray-800 text-gray-300 text-xs font-bold flex items-center justify-center">{initials(c.name)}</div>
    <div className="min-w-0 w-40 sm:w-56">
      <p className="font-bold text-white truncate">{c.name}</p>
      <p className="text-xs text-gray-500 truncate">{c.domain}</p>
    </div>
    <div className="flex-1 min-w-0 hidden sm:flex items-center gap-2 text-sm text-gray-300">
      <span className={`w-2 h-2 rounded-full shrink-0 ${DOT[c.status.tone]}`} />
      <span className="truncate" data-testid={`agent-feed-status-${c.id}`}>{c.status.text}</span>
    </div>
    <span className="hidden md:block text-sm font-mono text-gray-400 w-16 text-right">{c.ai_visibility ?? "—"}{c.ai_visibility != null && "/100"}</span>
    <button onClick={() => onOpen(c.id)} data-testid={`agent-feed-open-${c.id}`} className="ml-auto px-3 py-1.5 bg-purple-600 hover:bg-purple-500 text-white text-xs font-bold rounded-sm transition-colors">
      Otvoriť
    </button>
  </div>
);

export function AgencyAgentFeed({ userEmail }) {
  const [feed, setFeed] = useState(null);
  const [openId, setOpenId] = useState(null);
  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/agency/agent-feed`, agencyAuth(userEmail));
      setFeed(r.data);
    } catch { setFeed({ clients: [], pending_total: 0 }); }
  }, [userEmail]);
  useEffect(() => { load(); }, [load]);

  return (
    <section className="border border-gray-800 rounded-sm" data-testid="agency-agent-feed">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-800">
        <div className="flex items-center gap-2">
          <Bot className="w-4 h-4 text-purple-400" />
          <h2 className="font-black">Klienti a AI agent</h2>
          {feed?.pending_total > 0 && (
            <span className="px-2 py-0.5 text-[10px] font-bold bg-purple-600 rounded-full" data-testid="agent-feed-pending-total">{feed.pending_total} na schválenie</span>
          )}
        </div>
        <button onClick={load} className="p-1.5 text-gray-400 hover:text-white" aria-label="Obnoviť" data-testid="agent-feed-reload"><RefreshCw className="w-4 h-4" /></button>
      </div>
      {!feed && <div className="p-6 flex items-center gap-2 text-gray-400"><Loader2 className="w-4 h-4 animate-spin" /> Načítam…</div>}
      {feed && feed.clients.length === 0 && (
        <p className="p-6 text-sm text-gray-400" data-testid="agent-feed-empty">Zatiaľ nemáte klientov. Pridajte ich v záložke Klienti.</p>
      )}
      {feed?.clients.map((c) => <FeedRow key={c.id} c={c} onOpen={setOpenId} />)}
      <AgencyClientAiPanel userEmail={userEmail} clientId={openId} onClose={() => setOpenId(null)} onChanged={load} />
    </section>
  );
}
